import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "Code",
    accessorKey: "code",
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Supplier",
    cell: ({ row }) => <LetterAvatar name={row.original.supplier?.name} />,
  },
  {
    header: "Stock",
    accessorKey: "stock",
  },
]
